// mui
import { Tabs, Tab } from '@mui/material';

export type ActionStatusFilter = 'todo' | 'done';

export interface ActionStatusTabsProps {
  /** Currently active filter. */
  value: ActionStatusFilter;
  /** Fired when the user selects a different filter. */
  onChange: (value: ActionStatusFilter) => void;
}

const ITEMS: { value: ActionStatusFilter; label: string }[] = [
  { value: 'todo', label: 'To do' },
  { value: 'done', label: 'Done' },
];

/**
 * ActionStatusTabs is the All / To do / Done filter for the member actions list.
 * Renders as a segmented control via the themed `segmented` Tabs styling
 * (sunflower track, warm-orange selected pill — see theme/mui/components.ts).
 */
export const ActionStatusTabs = ({
  value,
  onChange,
}: ActionStatusTabsProps) => (
  <Tabs
    className='segmented'
    value={value}
    onChange={(_, next: ActionStatusFilter) => onChange(next)}
  >
    {ITEMS.map((item) => (
      <Tab
        key={item.value}
        value={item.value}
        label={item.label}
        disableRipple
      />
    ))}
  </Tabs>
);

ActionStatusTabs.displayName = 'ActionStatusTabs';
export default ActionStatusTabs;
